export default "__VITE_ASSET__CSvbxapf__"